/* TINOR — collection filtering, sorting and pagination via the Section Rendering API.
   Without JS everything still works: pills/sort/pagination are plain links and the
   filter drawer is a GET form (opened through :target). */
(() => {
  const ROOT = '[data-collection]';
  const cache = new Map();
  let controller = null;

  const root = () => document.querySelector(ROOT);

  function cleanUrl(url) {
    const u = new URL(url, location.origin);
    u.searchParams.delete('section_id');
    // drop empty params (e.g. blank price inputs)
    [...u.searchParams.keys()].forEach(k => {
      const vals = u.searchParams.getAll(k).filter(v => v !== '');
      u.searchParams.delete(k);
      vals.forEach(v => u.searchParams.append(k, v));
    });
    return u;
  }

  async function render(url, { push = true, scroll = false } = {}) {
    const el = root();
    if (!el) return;
    const u = cleanUrl(url);
    const fetchUrl = new URL(u);
    fetchUrl.searchParams.set('section_id', el.dataset.sectionId);

    if (controller) controller.abort();
    controller = new AbortController();
    el.classList.add('is-loading');

    try {
      let html = cache.get(fetchUrl.href);
      if (!html) {
        const res = await fetch(fetchUrl.href, { signal: controller.signal });
        if (!res.ok) throw new Error(res.status);
        html = await res.text();
        cache.set(fetchUrl.href, html);
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const focusId = document.activeElement && document.activeElement.id;
      const pills = el.querySelector('[data-pill-scroll]');
      const pillScroll = pills ? pills.scrollLeft : 0;
      const facetState = [...el.querySelectorAll('[data-swap="facets"] details')].map(d => d.open);

      el.querySelectorAll('[data-swap]').forEach(node => {
        const next = doc.querySelector('[data-swap="' + node.dataset.swap + '"]');
        if (next) node.replaceWith(document.importNode(next, true));
      });

      const newPills = el.querySelector('[data-pill-scroll]');
      if (newPills) newPills.scrollLeft = pillScroll;
      el.querySelectorAll('[data-swap="facets"] details').forEach((d, i) => { if (i in facetState) d.open = facetState[i]; });
      if (focusId) {
        const f = document.getElementById(focusId);
        if (f && el.contains(f)) f.focus({ preventScroll: true });
      }

      if (push) history.pushState({ collection: true }, '', u.pathname + u.search);

      if (scroll) {
        const toolbar = el.querySelector('[data-swap="toolbar"]');
        const results = el.querySelector('[data-swap="results"]');
        if (results) {
          const offset = (toolbar ? toolbar.offsetHeight : 0) + (parseInt(getComputedStyle(toolbar || results).top, 10) || 0);
          const top = results.getBoundingClientRect().top + window.scrollY - offset;
          if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
        }
      }
      if (window.TINOR && window.TINOR.init) window.TINOR.init(el.querySelector('[data-swap="results"]') || el);
    } catch (err) {
      if (err.name === 'AbortError') return;
      location.href = u.pathname + u.search;
    } finally {
      el.classList.remove('is-loading');
    }
  }

  function formUrl(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
    const path = new URL(form.action, location.origin).pathname;
    const qs = params.toString();
    return path + (qs ? '?' + qs : '');
  }

  // Links: pills, sort options, active filter removal, clear all, pagination
  document.addEventListener('click', e => {
    const el = root();
    if (!el) return;

    // Close links inside the drawer point at an anchor for no-JS; don't jump.
    const closeLink = e.target.closest('a[data-close]');
    if (closeLink && el.contains(closeLink)) e.preventDefault();

    const link = e.target.closest('a[data-filter-link]');
    if (link && el.contains(link)) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      const menu = link.closest('details');
      if (menu) menu.removeAttribute('open');
      render(link.href, { scroll: link.hasAttribute('data-scroll-top') || !!link.closest('.collection-toolbar') });
      return;
    }

    // Close the sort menu on outside click
    el.querySelectorAll('[data-sort-menu][open]').forEach(d => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(ROOT + ' [data-sort-menu][open]').forEach(d => {
      d.removeAttribute('open');
      const s = d.querySelector('summary');
      s && s.focus();
    });
  });

  // Filter form: checkboxes update instantly, price inputs on change (blur/enter)
  document.addEventListener('change', e => {
    const form = e.target.closest('[data-filter-form]');
    if (!form || !root()) return;
    render(formUrl(form));
  });

  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-filter-form]');
    if (!form || !root()) return;
    e.preventDefault();
    if (window.TINOR) window.TINOR.close(form);
    render(formUrl(form), { scroll: true });
  });

  window.addEventListener('popstate', () => {
    if (root()) render(location.href, { push: false });
  });
})();
